import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["name"]

import { ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InputMobile',
  props: {
  name: {
    type: String, // ชื่อ name ของ input
    required: true
  },
  username: String
},
  setup(__props) {

const props = __props


const username = ref(props.username);

const validateInput = (event: Event) => {
  const value = (event.target as HTMLInputElement).value;
  // กรองเฉพาะตัวเลข 0-9
  username.value = value.replace(/[^0-9]/g, '').slice(0, 10);
};

watch(() => props.username, (newVal) => {
  username.value = newVal; // อัพเดตค่า username ถ้ามีการเปลี่ยนแปลงจาก props
});


return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("input", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event)),
    name: __props.name,
    type: "text",
    class: "w-full rounded-md",
    onInput: validateInput,
    maxlength: "10"
  }, null, 40, _hoisted_1)), [
    [_vModelText, username.value]
  ])
}
}

})